import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_add_job",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "add_job",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_add_job_button",
  "data-kt-drawer-close": "#kt_drawer_add_job_close",
  "data-kt-drawer-width": "70.5vw"
}
const _hoisted_2 = {
  id: "kt_add_job",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_add_job_header\"><h2 class=\"fw-bolder text-light my-auto\">Add Job Placement</h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_add_job_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_add_job_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_add_job_body",
  "data-kt-scroll-dependencies": "#kt_add_job_header, #kt_add_job_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_add_job_scroll"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Employment Type", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Company Name", -1)
const _hoisted_14 = { class: "col-md-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Company Address", -1)
const _hoisted_16 = { class: "row mt-3" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Company Country", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Start Date", -1)
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Designation", -1)
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Department Name", -1)
const _hoisted_26 = { class: "row mt-3" }
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Remarks", -1)
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Company Contact Person Name", -1)
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Company Contact Person Email", -1)
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Company Contact Person Mobile", -1)
const _hoisted_35 = { class: "row mt-3" }
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Monthly Income/Salary(BDT)", -1)
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Supervisor Name", -1)
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Supervisor Email", -1)
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Supervisor Mobile", -1)
const _hoisted_44 = {
  class: "card-footer py-5 text-center",
  id: "kt_add_job_footer"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_drawer_add_job_close",
  class: "btn btn-danger me-5"
}, " Close ", -1)
const _hoisted_46 = ["data-kt-indicator"]
const _hoisted_47 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_48 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_49 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _hoisted_11,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Employment Type",
                        modelValue: _ctx.employment_type,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employment_type) = $event)),
                        onChange: _ctx.showDetails,
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Self Employment",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Self Employment")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Wages Employment",
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Wages Employment")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "UpSkill Employment",
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Upskill Employment")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.company_name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company_name) = $event)),
                        name: "company_name",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.company_address,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company_address) = $event)),
                        name: "company_address",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Company Country",
                        modelValue: _ctx.organization_country,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.organization_country) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryInfos, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info.id,
                              label: info.full_name,
                              value: info.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info.full_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_el_form_item, { class: "mb-0" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.start_date,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.start_date) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "dob",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.designation,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.designation) = $event)),
                        name: "designation",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.business_type,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.business_type) = $event)),
                        name: "business_type",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.remarks,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.remarks) = $event)),
                        name: "remarks",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.company_contact_person_name,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.company_contact_person_name) = $event)),
                        name: "company_contact_person_name",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.company_contact_person_email,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.company_contact_person_email) = $event)),
                        name: "company_contact_person_email",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.company_contact_person_mobile,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.company_contact_person_mobile) = $event)),
                        name: "company_contact_person_mobile",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.salary,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.salary) = $event)),
                        name: "salary",
                        class: "form-control",
                        type: "number",
                        min: "1000",
                        max: "1000000"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.supervisor_name,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.supervisor_name) = $event)),
                        name: "supervisor_name",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.supervisor_email,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.supervisor_email) = $event)),
                        name: "supervisor_email",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.supervisor_mobile,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.supervisor_mobile) = $event)),
                        name: "supervisor_mobile",
                        class: "form-control"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "button",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_48, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_50
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_46)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}